import { render, staticRenderFns } from "./CompareSection.vue?vue&type=template&id=065a54bc"
import script from "./CompareSection.vue?vue&type=script&lang=ts"
export * from "./CompareSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports